import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  NgZone,
  OnDestroy,
  PLATFORM_ID,
  CUSTOM_ELEMENTS_SCHEMA,
  ViewChild,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NewSidebarComponent } from '../sidebar-new/sidebar-addtional/new-sidebar/new-sidebar.component';
import { ToolbarComponent } from '../editor/additional/toolbar/toolbar.component';
import { EmptyContentComponent } from '../editor/additional/placeholders/empty-content.component';
import { UploadFileComponent } from '../editor/additional/placeholders/upload-file.component';
import { registerErrorSpanBlot } from '../editor/additional/custom-blots';
import { IconsComponent } from '../editor/additional/icons/icons.component';
import { ApidataService } from '../apidata.service';
import { ActivatedRoute } from '@angular/router';
import { TabviewSidebarComponent } from '../tabview-sidebar/tabview-sidebar.component';
import { Subject } from 'rxjs';
import { ModalComponent } from '../editor/additional/modals/modal.component';
import r from '../g-disable';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';

@Component({
  selector: 'app-paraphraserpro',
  standalone: true,
  imports: [
    CommonModule,
    NewSidebarComponent,
    ToolbarComponent,
    EmptyContentComponent,
    UploadFileComponent,
    IconsComponent,
    ModalComponent,
    TabviewSidebarComponent,
    IconsFreeToolsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './paraphraserpro.component.html',
  styleUrls: ['./paraphraserpro.component.css'],
})
export class ParaphraserproComponent implements AfterViewInit, OnDestroy {
  @ViewChild('editor', { static: true }) editorElement!: ElementRef;
  @ViewChild('editorToolbar', { static: true }) toolbarElement!: ElementRef;

  private paraphraserRequestSignal$ = new Subject<void>();
  private paraphraserStatusSignal$ = new Subject<void>();

  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);

  Object = Object;

  authLimits = {
    guest: {
      words: 1000,
    },
    auth: {
      words: 1000,
    },
    pro: {
      words: 10000,
    },
  };
  authTitle: string;
  authState: 'guest' | 'auth' | 'pro' = 'auth';

  profile_id = localStorage.getItem('profile_id') || '1';

  openMenu: HTMLElement | null = null;

  quillEditor: any;

  editorEnabled: boolean = true;
  editorLoaded: boolean = false;

  modes = [
    { name: 'AI Writer', value: 'AI_Writer' },
    { name: 'Smart Spin', value: 'smart_spin' },
    { name: 'Ultra Spin', value: 'ultra_spin' },
    { name: 'Spin Manual', value: 'spin_manual' },
  ];

  mode = 'smart_spin';

  editorState = {
    words: 0,
    characters: 0,
    res_words: 0,
    res_characters: 0,
    request: {
      hash: null,
      id: null,
    },
    content: null,
    state: 'initial',
  };

  languages: Record<string, { icon: string; name: string }> = {
    en: {
      icon: 'americanFlag',
      name: 'English US',
    },
    // 'en-gb': {
    //   icon: 'britishFlag',
    //   name: 'English UK',
    // },
    // 'en-ca': {
    //   icon: 'canadianFlag',
    //   name: 'English CAN',
    // },
    // 'en-au': {
    //   icon: 'australianFlag',
    //   name: 'English AUS',
    // },
    // 'en-in': {
    //   icon: 'indiaFlag',
    //   name: 'English IND',
    // },
    de: {
      icon: 'germanFlag',
      name: 'Deutsche - DE',
    },
    // nl: {
    //   icon: 'dutchFlag',
    //   name: 'Dutch - NL',
    // },
    // pt: {
    //   icon: 'portugueseFlag',
    //   name: 'Português - PT',
    // },
    // tr: {
    //   icon: 'turkishFlag',
    //   name: 'Turkish - TR',
    // },
    // fr: {
    //   icon: 'frenchFlag',
    //   name: 'Français - FR',
    // },
    // ru: {
    //   icon: 'russianFlag',
    //   name: 'Pусский - RU',
    // },
    es: {
      icon: 'spanishFlag',
      name: 'Español - ES',
    },
    // it: {
    //   icon: 'italianFlag',
    //   name: 'Italiano - IT',
    // },
  };
  selectedLanguage: keyof typeof this.languages = 'en';

  // selectedLanguage: keyof typeof this.languages = 'en';
  iconRequireReattachment = false;
  popup = {
    content: [],
    el: null,
    originalWord: null,
    description: null,
    x: 0,
    y: 0,
  };
  doc_id: string;

  constructor(
    private apiDataService: ApidataService,
    private route: ActivatedRoute
  ) {
    //
  }

  ngAfterViewInit() {
    this.loadEditor();

    this.route.queryParams.subscribe((params) => {
      this.doc_id = params['doc'];
    });

    if (isPlatformBrowser(this.platformId)) {
      r();

      if (this.profile_id !== '1') {
        this.apiDataService
          .getUserProfileContents(this.profile_id)
          .subscribe((data) => {
            this.authTitle = data.contents[0][5];
            if (
              data.contents[0][5] === 'premium_user' ||
              data.contents[0][5] === 'free_trial'
            ) {
              this.authState = 'pro';
            } else {
              this.authState = 'auth';
            }
          });

        this.apiDataService
          .getPreferredLangByProfileID(this.profile_id)
          .subscribe((data) => {
            const language = data.contents.toLowerCase();
            this.selectedLanguage = this.languages.hasOwnProperty(language)
              ? language
              : 'en';
            this.iconRequireReattachment = true;
            setTimeout(() => {
              this.iconRequireReattachment = false;
            });

            if (this.selectedLanguage !== 'en') {
              setTimeout(() => {
                this.paraphraserRequestSignal$.next();
                this.paraphrase();
              }, 500);
            }
          });
      } else {
        this.authState = 'guest';
      }

      setTimeout(() => {
        if (
          localStorage.getItem('editorValueAI') &&
          localStorage.getItem('editorValueAI') !== '<p><br></p>'
        ) {
          const content = new DOMParser()
            .parseFromString(localStorage.getItem('editorValueAI'), 'text/html')
            .body.textContent.trim();
          if (content.length) {
            this.quillEditor.root.innerHTML =
              localStorage.getItem('editorValueAI');

            setTimeout(() => {
              this.paraphrase();
            }, 0);
          } else {
            this.editorEnabled = false;
          }
          localStorage.removeItem('editorValueAI');
        } else {
          this.editorEnabled = false;
          this.apiDataService
            .onloadcontentresquest(
              localStorage.getItem('profile_id') || '1',
              this.doc_id
            )
            .subscribe((data) => {
              const content = new DOMParser()
                .parseFromString(data.outConts, 'text/html')
                .body.textContent.trim();
              if (content.length) {
                this.quillEditor.root.innerHTML = data.outConts;
                this.editorEnabled = true;
              }
            });
        }
      }, 100);
    }
  }

  ngOnDestroy() {
    this.paraphraserRequestSignal$.next();
    this.paraphraserStatusSignal$.next();
  }

  paraphrase() {
    this.editorState.content = null;
    this.editorState.res_characters = 0;
    this.editorState.res_words = 0;

    if (this.editorState.words > this.authLimits[this.authState].words) {
      document.getElementById(
        'content-exceeds-words-limit-modal'
      ).style.display = 'grid';
      this.quillEditor.enable();
      return;
    }

    if (
      localStorage.getItem('paraphrasing_lang') &&
      localStorage.getItem('paraphrasing_lang') !== this.selectedLanguage &&
      this.profile_id === '1'
    ) {
      this.selectedLanguage = localStorage.getItem('paraphrasing_lang');
      this.iconRequireReattachment = true;
      setTimeout(() => {
        this.iconRequireReattachment = false;
      });
      localStorage.removeItem('paraphrasing_lang');
    }

    this.editorState.state = 'loading';

    this.apiDataService
      .parapharsapi(
        this.quillEditor.getText(),
        this.selectedLanguage,
        this.mode,
        this.paraphraserRequestSignal$
      )
      .subscribe((data) => {
        if (
          data['status'] === 'unsupported or ambiguous language' ||
          data['status'] === 'unsupported language' ||
          data['request-hash'] === null
        ) {
          document.getElementById('error-content-modal').style.display = 'grid';
          this.editorState.state = 'initial';
          this.quillEditor.enable();
          return;
        }

        this.editorState.request.hash = data['request-hash'];
        this.editorState.request.id = data['request-id'];

        this.checkParaphrasingStatus();
      });
  }

  private checkParaphrasingStatus() {
    setTimeout(() => {
      this.apiDataService
        .parapharsstatus(
          this.editorState.request.hash,
          this.editorState.request.id,
          this.mode,
          this.paraphraserStatusSignal$
        )
        .subscribe((data) => {
          if (data['completion-percent'] === 100) {
            this.editorState.content = data['paraphrased_content'];

            setTimeout(() => {
              document.getElementById('HTPD2M2708').innerHTML =
                this.removeStyleAttributes(this.editorState.content);
              this.computeWordsAndCharactersCountForParaphrase();
            }, 1000);
            this.editorState.state = 'initial';
            this.saveEditorText();
          } else {
            this.checkParaphrasingStatus();
          }
        });
    }, 3000);
  }

  onResultsClick(event: Event) {
    const target = event.target as HTMLElement;

    if (target.tagName !== 'SPAN') return;

    this.popup.el = target;

    const words = target.dataset['def0'];
    this.popup.content = words.split('|').map((word) => word.trim());
    this.popup.originalWord = target.getAttribute('original');
    this.popup.description = this.popup.content[0];

    const verticalMargin = 20;
    const horizontalMargin = 15;
    const estimatedPopupWidth = 360;
    const estimatedPopupHeight = 120;

    const parent = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const rect = target.getBoundingClientRect();

    const editorWidth = parent.width;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    const placeAbove =
      spaceBelow < estimatedPopupHeight && spaceAbove > estimatedPopupHeight;

    let left = rect.left - parent.left;

    if (left + estimatedPopupWidth + horizontalMargin > editorWidth) {
      left = editorWidth - estimatedPopupWidth - horizontalMargin;
    } else if (left < horizontalMargin) {
      left = horizontalMargin;
    }

    let top = placeAbove
      ? rect.top - parent.top - estimatedPopupHeight - verticalMargin
      : rect.bottom - parent.top + verticalMargin;

    this.popup = {
      ...this.popup,
      x: left,
      y: top,
    };
  }

  private loadEditor() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        import('ngx-quill').then((module) => {
          import('quill').then((quillModule) => {
            this.ngZone.run(() => {
              this.initializeEditor(module, quillModule);
            });
          });
        });
      });

      document.addEventListener('click', this.handleClickOutside);
    }
  }
  private initializeEditor(quillModule: any, quillImport: any) {
    const Quill = quillImport.default;
    registerErrorSpanBlot(Quill);
    this.editorLoaded = true;

    const editorConfig = {
      modules: {
        toolbar: {
          container: this.toolbarElement.nativeElement,
        },
      },
      placeholder: '',
      theme: 'snow',
    };

    this.quillEditor = new Quill(
      this.editorElement.nativeElement,
      editorConfig
    );

    this.quillEditor.root.id = 'mm';

    this.addEventListeners();
  }
  private addEventListeners() {
    if (!this.quillEditor) return;

    const q = this.quillEditor;

    q.on('text-change', () => {
      this.editorEnabled = true;
      this.computeWordsAndCharactersCount();
    });

    q.root.addEventListener('blur', () => {
      this.editorEnabled =
        !!this.editorState.characters ||
        this.quillEditor.root.innerHTML !== '<p><br></p>';
    });

    q.root.addEventListener('paste', () => {
      q.root.querySelectorAll('img').forEach((img) => img.remove());
      q.root
        .querySelectorAll('[style]')
        .forEach((el) => el.removeAttribute('style'));
    });
  }

  computeWordsAndCharactersCount() {
    const editorText = this.quillEditor.getText().trim();
    const words = editorText.length ? editorText.split(/\s+/) : [];

    this.editorState.words = words.length;
    this.editorState.characters = editorText.length;
  }

  renderEditor() {
    this.editorEnabled = true;

    this.quillEditor.root.focus();
  }

  f(number: number): string {
    return number.toLocaleString();
  }

  handleClickOutside = (event: Event) => {
    if (this.openMenu && !this.openMenu.contains(event.target as Node)) {
      this.openMenu.style.display = 'none';
      this.openMenu = null;
    }

    if (this.popup.content.length) {
      if (
        !(
          this.popup.el === event.target ||
          !!(event.target as HTMLElement).closest('.popup')
        )
      )
        this.dismissPopup();
    }
  };

  toggleReportMenu(event: Event) {
    event.stopPropagation();

    const target = (event.target as HTMLElement).closest('button')
      ?.nextElementSibling as HTMLUListElement;

    if (!target) return;

    if (this.openMenu && this.openMenu !== target) {
      this.openMenu.style.display = 'none';
    }

    const cn: string = target.classList.contains('language-menu')
      ? 'grid'
      : 'block';

    target.style.display = target.style.display === cn ? 'none' : cn;
    this.openMenu = target.style.display === cn ? target : null;
  }

  private removeStyleAttributes(html: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const elements = Array.from(doc.body.children);

    elements.forEach((el) => {
      el.removeAttribute('style');
    });

    return doc.body.innerHTML;
  }

  handlePopupClick(event: Event) {
    const target = (event.target as HTMLElement).closest('button');

    const replacement = target.dataset['replacement'];

    this.popup.el.innerText = replacement;

    this.dismissPopup();

    setTimeout(() => {
      this.computeWordsAndCharactersCountForParaphrase();
    }, 0);
  }

  dismissPopup() {
    this.popup.content = [];
    this.popup.el = null;
    this.popup.originalWord = null;
    this.popup.description = null;
  }

  computeWordsAndCharactersCountForParaphrase() {
    const text = document.getElementById('HTPD2M2708').innerText;

    this.editorState.res_words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    this.editorState.res_characters = text.length;
  }

  copyToClipboard() {
    navigator.clipboard.writeText(
      (document.querySelector('#HTPD2M2708') as HTMLElement).innerText
    );
  }

  clearEditor() {
    this.quillEditor.setText(null);
    this.editorState.words = 0;
    this.editorState.characters = 0;
    this.editorState.content = null;
    this.editorState.res_characters = 0;
    this.editorState.res_words = 0;
    this.editorEnabled = false;

    for (let i = 0; i < 2; i++) {
      setTimeout(() => {
        this.paraphraserRequestSignal$.next();
        this.paraphraserStatusSignal$.next();
      }, i * 1000);
    }

    this.editorState.state = 'initial';
    this.saveEditorText();
  }

  saveEditorText() {
    const content = this.quillEditor.root.innerHTML;

    this.apiDataService
      .auto_saved_Api(
        localStorage.getItem('profile_id') || '1',
        'Paraphraser',
        'Paraphraser',
        content,
        this.doc_id,
        'paraphraser'
      )
      .subscribe();
  }

  invokeModal(event: Event) {
    const targetId = (event.target as HTMLElement).closest('button').dataset[
      'target'
    ];

    document.getElementById(targetId).style.display = 'grid';
  }

  dismissModal(event: Event) {
    (
      (event.target as HTMLElement).closest('.wrapper') as HTMLElement
    ).style.display = 'none';
  }

  switchLanguage(event) {
    const el = (event.target as HTMLElement).closest('li');

    if (!el) return;

    const language = el.getAttribute('data-language');
    this.selectedLanguage = language;
    this.openMenu.style.display = 'none';

    this.profile_id !== '1' &&
      this.apiDataService
        .updateUserLanguage(this.profile_id, language)
        .subscribe();

    this.iconRequireReattachment = true;
    setTimeout(() => {
      this.iconRequireReattachment = false;
    });
  }
  @ViewChild('output', { static: false }) output!: ElementRef;

  downloadReport() {
    const outputElement = this.output?.nativeElement;

    if (outputElement) {
      const textContent = outputElement.innerText.trim();

      if (!textContent) {
        alert('No text to download.');
        return;
      }

      const blob = new Blob([textContent], {
        type: 'text/plain;charset=utf-8',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = 'PP_text.txt';
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  }
}
